import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';

import { IUserService, USER_SERVICE } from '@data-access/repository';

import { ILoggerService, LOGGER_SERVICE } from '@shared/services';

import { SUPER_USER_CHECK_FAILED_MESSAGE } from '../constants/error.constants';

@Injectable({
  providedIn: 'root'
})
export class SuperUserGuard implements CanActivate {
  private userService = inject<IUserService>(USER_SERVICE);
  readonly #loggerService = inject<ILoggerService>(LOGGER_SERVICE);
  private readonly router = inject(Router);

  public canActivate(): Observable<boolean | UrlTree> {
    return this.userService.hasSuperUserPrivileges().pipe(
      map(response =>
        response.isSuccess() && response.value.getValue() ? true : this.router.createUrlTree(['/access-denied'])
      ),
      catchError(error => {
        this.#loggerService.error(SUPER_USER_CHECK_FAILED_MESSAGE, error);
        return of(this.router.createUrlTree(['/access-denied']));
      })
    );
  }
}
